import { __decorate } from "tslib";
import { AutoEncoder, EmailDecoder, field } from '@simonbackx/simple-encoding';
export class ForgotPasswordRequest extends AutoEncoder {
    email;
}
__decorate([
    field({ decoder: EmailDecoder })
], ForgotPasswordRequest.prototype, "email", void 0);
//# sourceMappingURL=ForgotPasswordRequest.js.map